import { GeoUnitType } from '@models/partners/partner-const-types';
import { GenericGeoUnit } from '@shared/models/generic-geo-unit';
import { CountryCode } from 'libphonenumber-js';

export const defaultGeoUnits: GenericGeoUnit<GeoUnitType.COUNTRY>[] = [
  {
    countryCode: 'KZ' as CountryCode,
    id: 1,
    name: 'Казахстан',
    parentId: null,
    type: GeoUnitType.COUNTRY,
  },
  {
    countryCode: 'KG' as CountryCode,
    id: 144,
    name: 'Кыргызстан',
    parentId: null,
    type: GeoUnitType.COUNTRY,
  },
  {
    countryCode: 'UZ' as CountryCode,
    id: 147,
    name: 'Узбекистан',
    parentId: null,
    type: GeoUnitType.COUNTRY,
  },
  {
    countryCode: 'TJ' as CountryCode,
    id: 750,
    name: 'Таджикистан',
    parentId: null,
    type: GeoUnitType.COUNTRY,
  },
];
